import { Link } from 'react-router-dom'
import { VersionDisplay } from '@/components/VersionDisplay'

export default function Footer() {
  return (
    <footer className="bg-quantum-blue text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e descrição */}
          <div className="md:col-span-1">
            <img
              src="/img/geral/logo-quantum-branca.png"
              alt="Sistema Quantum"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-blue-200 leading-relaxed">
              Gestão e controle sem complicação para o seu negócio.
            </p>
            <div className="flex gap-4 mt-4">
              <a href="https://www.facebook.com/QuantumSistemas/" target="_blank" rel="noreferrer"
                className="text-blue-200 hover:text-white transition-colors">
                <i className="fa-brands fa-facebook text-xl" />
              </a>
              <a href="https://www.instagram.com/sistemaquantum" target="_blank" rel="noreferrer"
                className="text-blue-200 hover:text-white transition-colors">
                <i className="fa-brands fa-instagram text-xl" />
              </a>
              <a href="https://www.youtube.com/@sistemaquantum9982" target="_blank" rel="noreferrer"
                className="text-blue-200 hover:text-white transition-colors">
                <i className="fa-brands fa-youtube text-xl" />
              </a>
            </div>
          </div>

          {/* Links rápidos */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-blue-200">
              Empresa
            </h3>
            <ul className="space-y-2 text-sm">
              {[
                { to: '/quem-somos', label: 'Quem Somos' },
                { to: '/solucoes', label: 'Soluções' },
                { to: '/faq', label: 'FAQ' },
                { to: '/agendar-visita', label: 'Agende uma Visita' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-blue-200 hover:text-white transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Central do Usuário */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-blue-200">
              Central do Usuário
            </h3>
            <ul className="space-y-2 text-sm">
              {[
                { to: '/imprimir-boleto', label: 'Imprimir Boleto' },
                { to: '/senha-mensal', label: 'Senha Mensal' },
                { to: '/baixar-suporte', label: 'Baixar Suporte' },
                { to: '/acesso-contador', label: 'Acesso Contador' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-blue-200 hover:text-white transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="font-semibold text-sm uppercase tracking-wider mb-4 text-blue-200">
              Contato
            </h3>
            <ul className="space-y-3 text-sm text-blue-200">
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-location-dot mt-0.5" />
                <span>Palmas - TO, Brasil</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-phone" />
                <a href="tel:+556332143357" className="hover:text-white transition-colors">
                  (63) 3214-3357
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-brands fa-whatsapp" />
                <a href="https://wa.me/5563984042819" target="_blank" rel="noreferrer"
                  className="hover:text-white transition-colors">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-envelope" />
                <a href="mailto:contato@sistemaquantum.com.br" className="hover:text-white transition-colors">
                  contato@sistemaquantum.com.br
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <div className="border-t border-blue-800 py-4">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-blue-300">
          <span>© {new Date().getFullYear()} Sistema Quantum. Todos os direitos reservados.</span>
          <VersionDisplay variant="muted" align="center" className="text-blue-300" />
          <span>Gestão e controle sem complicação!</span>
        </div>
      </div>
    </footer>
  )
}
